<div class="support">
  <div class="support-header">
    <div class="title">Support</div>
    <div class="close" (click)="closeSupport()"></div>
  </div>

  <div *ngIf="!activeDoc">
    <div class="search">
      <input type="text" placeholder="Search docs..." [(ngModel)]="searchText" (keyup.enter)="searchDocs()" />
      <div class="clear-search" (click)="clearSearch()">X</div>
      <div class="search-button" (click)="searchDocs()">Search</div>
    </div>
  </div>

  <div *ngIf="!activeDoc" class="docs">
    <div *ngIf="supportDocs && supportDocs.length == 0 && searchText  != ''" class="no-results">no results</div>
    <div *ngFor="let doc of supportDocs" class="doc">
      <div class="doc-name" (click)="loadDoc(doc._id)">{{doc.name}}</div>
      <div class="doc-content" [class.expanded]="doc.expanded">
        <!--
        <div *ngFor="let element of doc.content" [innerHTML]="element.value | rf:'safeHtml'"></div>
        -->
        <!-- <div [innerHTML]="doc.content.value | rf:'safeHtml'"></div> -->
      </div>
    </div>
  </div>

  <div *ngIf="activeDoc" class="doc-viewer">
    <div class="doc-viewer-header">
      <div class="doc-viewer-back" (click)="closeDoc()">Back</div>
      <div class="doc-viewer-title">{{activeDoc.name}}</div>
    </div>
    <div class="doc-viewer-content">
      <ng-container *ngFor="let element of activeDoc.content">
        <div *ngIf="element.type == 'text'" class="doc-text" [innerHTML]="element.value | rf:'safeHtml'"></div>
        <div *ngIf="element.type == 'image'" class="doc-image">
          <img [src]="element.value" alt="{{activeDoc.name}}" />
        </div>
      </ng-container>
    </div>
  </div>

  <div class="support-footer">
    <div>
      <a href="mailto:support@redfiretechnology.com" target="_blank">support&#64;redfiretechnology.com</a>
    </div>
    <div>
      <a href="tel:+1-866-818-6005">(866)&nbsp;818-6005</a>
    </div>
    <div class="version">Quartz v{{version}}</div>
  </div>

</div>